import type { AgentRuntimeOptionsValue } from "@models/doctype";
import { AGENT_RUNTIME_SECTIONS, OptionSections } from "./RuntimeOptions";

interface AgentRuntimeOptionsFieldsProps {
    value: AgentRuntimeOptionsValue | null;
    onChange: (value: AgentRuntimeOptionsValue | null) => void;
    onDirty?: () => void;
}

export const AgentRuntimeOptionsFields = ({
    value,
    onChange,
    onDirty,
}: AgentRuntimeOptionsFieldsProps) => (
    <OptionSections
        sections={AGENT_RUNTIME_SECTIONS}
        value={value}
        onChange={(next) => {
            onChange(next);
            onDirty?.();
        }}
    />
);
